import { render, staticRenderFns } from "./InputDash.vue?vue&type=template&id=56974431&scoped=true&"
import script from "./InputDash.vue?vue&type=script&lang=js&"
export * from "./InputDash.vue?vue&type=script&lang=js&"
import style0 from "./InputDash.vue?vue&type=style&index=0&id=56974431&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56974431",
  null
  
)

export default component.exports